<template>
    <div>
        <branding :can-create="false"
                  :can-edit="false"
                  class="left-0 -top-4 w-full overflow-hidden mx-[6.4rem]"
                  position="fixed"
        ></branding>

        <div class="w-full h-full bg-primary opacity-30 absolute inset-0"></div>

        <div class="bg-white shadow-md my-64 rounded mx-auto relative z-10 p-48 w-full max-w-640">
            <popup-content :description="$t('free_trial.branding.description')"
                           :progress="30"
                           :title="$t('free_trial.branding.title')"
                           icon="format-paint"
            ></popup-content>

            <div class="first-letter:uppercase mb-4 mt-16 text-body">
                {{ $t('settings.company.logo') }}
            </div>
            <p class="mb-12">{{ $t('free_trial.branding.upload_logo') }}</p>
            <siu v-model="photo_path_queued_id"
                 :image="logoUrl"
                 :isSquare="true"
                 :minHeight="100"
                 :minWidth="150"
                 class="mb-32"
                 classes="h-160 rounded shadow-md"
                 icon-location="corner"
                 @clear="clearLogo"
                 @success="resetLogo">
            </siu>

            <div class="first-letter:uppercase mb-4 mt-16 text-body">
                {{ $t('free_trial.branding.accent_color') }}
            </div>
            <p class="mb-8">{{ $t('free_trial.branding.select_color', {company: currentCompany.name}) }}</p>

            <color-selector :background="brandHSLA" :value="primary_color" class="mt-4" @input="primary_color = $event.hsl">
                <template #default>
                    <span class="text-primary-80">
                        {{ $t('site_editor.layout.colors.brand.title') }}
                    </span>
                </template>
                <template #description>
                    <span class="text-primary-80">
                        {{ $t('free_trial.branding.click_here_color') }}
                    </span>
                </template>
            </color-selector>

            <div class="mt-48 flex justify-center space-x-20">
                <simple-button class="uppercase w-200"
                               look="secondary"
                               @click="$emit('previous', 2)">
                    {{ $t('general.back') }}
                </simple-button>


                <simple-button :loading="loading"
                               class="uppercase w-200"
                               display="secondary"
                               look="primary"
                               @click="handleNextStep">
                    {{ $t('jobs.next_step') }}
                </simple-button>
            </div>
        </div>
    </div>
</template>

<script>
import {mapState, mapActions} from 'pinia';
import {useRepo} from 'pinia-orm';
import {useMainStore} from '../../../state/store';
import {useBrandingStore} from '../../../../shared/state/branding';
import {normalizeJson} from '../../../../shared/helpers';
import * as companies from '../../../services/CompanyService';
import * as jobsites from '../../../services/JobsiteService';
import Company from '../../../models/Company';
import Jobsite from '../../../models/Jobsite';
import SimpleButton from '../SimpleButton.vue';
import SingleImageUpload from '../../forms/SingleImageUpload.vue';
import ColorSelector from '../ColorSelector.vue';
import Branding from '../../../views/Branding.vue';
import PopupContent from './PopupContent.vue';

export default {
    name: 'BrandingInfo',
    components: {
        PopupContent,
        Branding,
        'color-selector': ColorSelector,
        'siu': SingleImageUpload,
        'simple-button': SimpleButton,
    },
    data() {
        return {
            choice: null,
            photo_path_queued_id: null,
            primary_color: this.currentCompany.jobsite.primary_color,
            data: {
                logo_path_queued_id: null,
                logo_path: 'default',
            },
            loading: null,
        };
    },
    computed: {
        ...mapState(useMainStore, ['currentCompany']),
        ...mapState(useBrandingStore, ['brandHSLA']),
        logoUrl() {
            return (typeof this.currentCompany.logo_url) ? this.currentCompany.logo_url : null;
        },
    },
    methods: {
        ...mapActions(useBrandingStore, ['setPrimaryColor']),
        clearLogo() {
            this.data.logo_path = null;
            delete this.data.logo_path_queued_id;


            companies.update(this.currentCompany.id, {data: {attributes: this.data}}).then(result => {
                return useRepo(Company).save(normalizeJson(result));
            });
        },
        resetLogo(logo) {
            //show loader on siu until company fully updated


            this.data.logo_path_queued_id = logo.id;
            delete this.data.logo_path;

            companies.update(this.currentCompany.id, {data: {attributes: this.data}}).then(result => {
                return useRepo(Company).save(normalizeJson(result));
            });
            // this.form.data.logo_path = 'default';
        },
        handleNextStep() {
            this.loading = true;

            jobsites.update(this.currentCompany.id, {
                data: {
                    attributes: {
                        primary_color: this.primary_color,
                    },
                },
            }).then(result => {
                this.loading = false;

                useRepo(Jobsite).save(normalizeJson(result));

                return this.$emit('next');
            });
        },
    },
    watch: {
        primary_color: {
            handler(primary_color) {
                this.setPrimaryColor(primary_color);
            },
            deep: true,
            immediate: true,
        },
    },
};
</script>
